import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpUtilsService } from '../utils/http-utils.service';
import * as globals from '../../../../../global';
import { BehaviorSubject } from 'rxjs';
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { base_url } from "../../../../../global";

@Injectable()
export class ProfileService {
    // Used when the managed plan type list can't be loaded. A new array each time so
    // callers can't mutate the fallback for everyone else.
    public static get DEFAULT_PLAN_TYPE_OPTIONS(): any[] {
        return [
            { key: 'Basic', value: 1 },
            { key: 'Pro', value: 2 },
            { key: 'Extras', value: 3 },
            { key: 'Free Trial', value: 4 }
        ];
    }

    public xhr = null;
    public apiResponse: boolean = true;
    public cancelRequest() {
        if (this.xhr && !this.xhr.closed) {
            this.xhr.unsubscribe();
        }
    }

    API_URL: any = base_url;

    get imageUrl() {
        return this._imageUrl;
    }

    set imageUrl(value) {
        this._imageUrl = value;
    }
    constructor(private http: HttpClient, private httpUtils: HttpUtilsService) { }

    public listuserrequests() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http
            .post(this.API_URL + 'user-request/list', {
                "page": 1
            }, { headers: headers }
            );
    }

    public listuserrequestsfordrop() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'user-request/list',
            {},
            { headers: headers })
    }

    public viewrequests(id) {
        let formData = {
            user_id: id
        };
        return this.http.post(this.API_URL + 'user-request/view', formData);
    }
    public viewuserdata(id) {
        let formData = {
            user_id: id
        };
        return this.http.post(this.API_URL + 'user/view', formData);
    }

    public acceptrequest(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
       
        return this.http.post(this.API_URL + 'user-request/accept',
            formData, { headers: headers });
    }


    public rejectrequest(rejectlist) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'user-request/reject',
            rejectlist, { headers: headers });
    }

    //   public manageremoveaed(params) {
    // 		const headers = this.httpUtils.getHTTPHeaders();
    // 		return this.http.post(this.API_URL+'aed/remove-request/list',
    // 		{
    //            params  
    // 		}, {headers: headers});
    //     }

    public manageremoveaed(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            //  this.http.post(this.API_URL + 'user/list', params, {headers: headers})
            this.xhr = this.http.post(this.API_URL + 'aed/remove-request/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public deleteremoveaedrequest(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'aed/remove-request/delete',
            {
                id: id
            }, { headers: headers });
    }

    public rejectremoveaedrequest(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'aed/remove-request/reject',
            {
                id: id
            }, { headers: headers });
    }

    public viewremoveaedrequest(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'aed/remove-request/view',
            {
                id: id
            }, { headers: headers });
    }

    //   public managelibrary(params){
    //       const headers = this.httpUtils.getHTTPHeaders();
    //       return this.http.post(this.API_URL+'library/list',
    //       {
    //        params
    //       }, {headers:headers});
    //   }

    public managelibrary(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            //  this.http.post(this.API_URL + 'library/list', params, {headers: headers})
            this.xhr = this.http.post(this.API_URL + 'library/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public deletelibrary(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'library/delete',
            formData
            , { headers: headers })
    }

    public viewlibrary(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'library/view', {
            library_id: id
        }, { headers: headers })
    }

    public assignLibraryToAll(libraryId: number): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'library/assign-to-all', {
            library_id: libraryId
        }, { headers: headers });
    }


    public updateformData(form): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        let formData: FormData = new FormData();
        //   formData.append('file', image);
        formData.append('title', form.title);
        formData.append('file', form.file);
        formData.append('library_id', form.library_id)
        return this.http.post(this.API_URL + 'library/edit',
            formData
            , { headers: headers })
    }


    public makeFileRequestForFormData(form): Observable<any> {

        const headers = this.httpUtils.getHTTPHeaders();
        let formData: FormData = new FormData();
        //   formData.append('file', image);
        formData.append('title', form.title);
        formData.append('file', form.file);
        formData.append('is_master', form.is_master);
        formData.append('companies', JSON.stringify(form.company));
        return this.http.post(this.API_URL + 'library/edit',
            formData
            , { headers: headers })
    }

    public makeFileForeditFormData(form): Observable<any> {

        const headers = this.httpUtils.getHTTPHeaders();
        let formData: FormData = new FormData();
        //   formData.append('file', image);
        formData.append('library_id', form.library_id);
        formData.append('title', form.title);
        if(form.file && form.file !== undefined){
            formData.append('file', form.file);
        }
        return this.http.post(this.API_URL + 'library/edit',
            formData
            , { headers: headers })
    }

    public makeFormDataAddCompany(form): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        let formData: FormData = new FormData();
        formData.append('company_code', form.company_code);
        formData.append('company_name', form.company_name);
        formData.append('company_phone', form.company_phone);
        formData.append('company_email', form.company_email);
        if(form.reseller_id && form.reseller_id !== undefined){
            formData.append('reseller_id', form.reseller_id);
        }
        formData.append('company_logo', form.company_logo);
        formData.append('redirect_store', form.redirect_store ? '1' : '0');
        formData.append('new_hub_enabled', form.new_hub_enabled ? '1' : '0');
        formData.append('inspection_photo_required', form.inspection_photo_required ? '1' : '0');
        if(form.classification_id !== null && form.classification_id !== undefined){
            formData.append('classification_id', form.classification_id);
        }
        if(form.customer_type_id !== null && form.customer_type_id !== undefined){
            formData.append('customer_type_id', form.customer_type_id);
        }
        if(form.address_1){ formData.append('address_1', form.address_1); }
        if(form.address_2){ formData.append('address_2', form.address_2); }
        if(form.city){ formData.append('city', form.city); }
        if(form.state){ formData.append('state', form.state); }
        if(form.zip_code){ formData.append('zip_code', form.zip_code); }
        if(form.country){ formData.append('country', form.country); }
        if(form.program_start_date !== null && form.program_start_date !== undefined){
            formData.append('program_start_date', form.program_start_date);
        }
        // 0 is a real Paid Programs count, so check for null/blank instead of truthiness.
        if(form.paid_programs !== null && form.paid_programs !== undefined && form.paid_programs !== ''){
            formData.append('paid_programs', form.paid_programs);
        }
        // Billing information
        if(form.billing_contact_name){ formData.append('billing_contact_name', form.billing_contact_name); }
        if(form.billing_contact_email){ formData.append('billing_contact_email', form.billing_contact_email); }
        if(form.billing_contact_phone){ formData.append('billing_contact_phone', form.billing_contact_phone); }
        if(form.billing_address_1){ formData.append('billing_address_1', form.billing_address_1); }
        if(form.billing_address_2){ formData.append('billing_address_2', form.billing_address_2); }
        if(form.billing_city){ formData.append('billing_city', form.billing_city); }
        if(form.billing_state){ formData.append('billing_state', form.billing_state); }
        if(form.billing_zip_code){ formData.append('billing_zip_code', form.billing_zip_code); }
        if(form.billing_country){ formData.append('billing_country', form.billing_country); }
        return this.http.post(this.API_URL + 'company/add',
            formData
            , { headers: headers })
    }

    public makeFormDataupdateCompany(form): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        let formData: FormData = new FormData();
        formData.append('company_code', form.company_code);
        formData.append('company_name', form.company_name);
        formData.append('company_phone', form.company_phone);
        formData.append('company_email', form.company_email);
        formData.append('redirect_store', form.redirect_store);
        formData.append('pulsepoint_enabled', form.pulsepoint_enabled);
        formData.append('zoll_wifi_enabled', form.zoll_wifi_enabled);
        formData.append('stryker_enabled', form.stryker_enabled);
        formData.append('new_hub_enabled', form.new_hub_enabled);
        if(form.inspection_photo_required !== undefined && form.inspection_photo_required !== null){
            formData.append('inspection_photo_required', form.inspection_photo_required);
        }
        if(form.classification_id !== null && form.classification_id !== undefined){
            formData.append('classification_id', form.classification_id);
        }
        if(form.customer_type_id !== null && form.customer_type_id !== undefined){
            formData.append('customer_type_id', form.customer_type_id);
        }
        if(form.address_1){ formData.append('address_1', form.address_1); }
        if(form.address_2){ formData.append('address_2', form.address_2); }
        if(form.city){ formData.append('city', form.city); }
        if(form.state){ formData.append('state', form.state); }
        if(form.zip_code){ formData.append('zip_code', form.zip_code); }
        if(form.country){ formData.append('country', form.country); }
        if(form.program_start_date !== null && form.program_start_date !== undefined){
            formData.append('program_start_date', form.program_start_date);
        }
        // Billing information
        if(form.billing_contact_name){ formData.append('billing_contact_name', form.billing_contact_name); }
        if(form.billing_contact_email){ formData.append('billing_contact_email', form.billing_contact_email); }
        if(form.billing_contact_phone){ formData.append('billing_contact_phone', form.billing_contact_phone); }
        if(form.billing_address_1){ formData.append('billing_address_1', form.billing_address_1); }
        if(form.billing_address_2){ formData.append('billing_address_2', form.billing_address_2); }
        if(form.billing_city){ formData.append('billing_city', form.billing_city); }
        if(form.billing_state){ formData.append('billing_state', form.billing_state); }
        if(form.billing_zip_code){ formData.append('billing_zip_code', form.billing_zip_code); }
        if(form.billing_country){ formData.append('billing_country', form.billing_country); }
        if(form.company_logo && form.company_logo !== undefined){
            formData.append('company_logo', form.company_logo);
        }
        // if(form.reseller_id && form.reseller_id !== undefined){
            formData.append('reseller_id', form.reseller_id ? form.reseller_id: 0);
        // }
        formData.append('company_id', form.company_id);
        // Primary Account Contact
        if (form.primary_contact_id !== null && form.primary_contact_id !== undefined && form.primary_contact_id !== '') {
            formData.append('primary_contact_id', form.primary_contact_id);
        } else {
            formData.append('primary_contact_id', '');
        }
        // Digest email settings. Hour 0 is 12:00 AM and must not be treated as empty.
        if (form.digest_send_hour !== null && form.digest_send_hour !== undefined && form.digest_send_hour !== '') {
            formData.append('digest_send_hour', form.digest_send_hour);
        }
        if (form.digest_timezone) {
            formData.append('digest_timezone', form.digest_timezone);
        }
        // Plan details. Appended with explicit null/undefined/'' checks rather than
        // the truthiness guard used above: 0 is a real Paid Programs count, and a
        // blank has to reach the API to clear a plan or a renewal date.
        if (form.primary_ms_id !== null && form.primary_ms_id !== undefined) {
            formData.append('primary_ms_id', form.primary_ms_id);
        } else {
            formData.append('primary_ms_id', '');
        }
        if (form.paid_programs !== null && form.paid_programs !== undefined && form.paid_programs !== '') {
            formData.append('paid_programs', form.paid_programs);
        } else {
            formData.append('paid_programs', '');
        }
        if (form.plan_renewal_date !== null && form.plan_renewal_date !== undefined) {
            formData.append('plan_renewal_date', form.plan_renewal_date);
        } else {
            formData.append('plan_renewal_date', '');
        }
        // Shipping override is a toggle, so 0 has to go up or it can never be
        // turned back off.
        formData.append('override_shipping_address', form.override_shipping_address ? '1' : '0');
        return this.http.post(this.API_URL + 'company/edit',
            formData
            , { headers: headers })
    }

    public bulkUpdatePulsePoint(data): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/bulk-update-pulsepoint', data, { headers: headers });
    }

    public bulkUpdateZollWifi(data): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/bulk-update-zoll-wifi', data, { headers: headers });
    }

    public bulkUpdateStryker(data): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/bulk-update-stryker', data, { headers: headers });
    }

    public bulkUpdateNewHub(data): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/bulk-update-new-hub', data, { headers: headers });
    }

    public bulkUpdateClassification(data): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/bulk-update-classification', data, { headers: headers });
    }

    public updateGlobalInspector(form): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + `global-inspector/edit`, form, { headers: headers })
    }

    public checkEmail(email): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + `global-inspector/check-email?email=${email}`
            , {}, { headers: headers })
    }

    public viewcompany(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/view', {
            company_id: id
        }, { headers: headers })
    }

    public viewInspector(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'global-inspector/view', {
            user_id: id
        }, { headers: headers })
    }

    // public listmanagecompany(params) {
    //     const headers = this.httpUtils.getHTTPHeaders();
    //     return this.http.post(this.API_URL+'company/list',
    //     {
    //     params
    //     },{headers:headers})
    //   }
    // public listmanagecompany() {
    //     const headers = this.httpUtils.getHTTPHeaders();
    //     return this.http.post(this.API_URL+'company/list',
    //     {
    //         // "page": 1,
    //         // "show_all": 0,
    //         // "search": "",
    //         // "new_also": ""

    //     },{headers:headers})
    //   }
    public viewSite(id) {
        let formData = {
            site_id: id
        };
        return this.http.post(this.API_URL + 'site/view', formData);
    }
    // public manageremoveaedview(id) {
    // 	const headers = this.httpUtils.getHTTPHeaders();
    // 	return this.http.post(this.API_URL+'aed/remove-request/list',
    // 	{
    //         id: id
    // 	}, {headers: headers});
    // }

    public listmanagecompany(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            //  this.http.post(this.API_URL + 'user/list', params, {headers: headers})
            this.xhr = this.http.post(this.API_URL + 'company/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public deletecompany(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/delete',
            formData
            , { headers: headers })
    }

    public deleteInspector(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + `global-inspector/delete?user_id=${id}`
            , { headers: headers })
    }


    // public getManageAdminUserList(params) {
    //     const headers =this.httpUtils.getHTTPHeaders();
    //     return this.http.post(this.API_URL+'admin/list', params,{headers:headers})
    // }


    public getManageAdminUserList(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            //  this.http.post(this.API_URL + 'admin/list', params, {headers: headers})
            this.xhr = this.http.post(this.API_URL + 'admin/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public viewadminuser(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'admin/view', {
            user_id: id
        }, { headers: headers })
    }

    public addadminuser(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'admin/edit', formData, { headers: headers })
    }

    public deleteadminuser(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'admin/delete',
            formData
            , { headers: headers })
    }

    public changeAdminStatus(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'admin/change-status',
            formData
            , { headers: headers })
    }

    public listSalesReps(): Observable<any> {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'admin/sales-rep-list', {}, { headers: headers });
    }

    // public listmasteraedmake(params) {
    //     const headers =this.httpUtils.getHTTPHeaders();
    //     return this.http.post(this.API_URL+'master/make/list',
    //     params
    //     ,{headers:headers})
    // }

    public listmasteraedmake(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            //  this.http.post(this.API_URL + 'user/list', params, {headers: headers})
            this.xhr = this.http.post(this.API_URL + 'master/make/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public listmasteraedmakefordrop() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/make/list',
            {},
            { headers: headers })
    }

    public deletemasteraedmake(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/make/delete',
            formData,
            { headers: headers })
    }

    public editmasteraedmake(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/make/update', formData, { headers: headers })
    }

    public viewmasteraedmake(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/make/view', {
            make_id: id
        }, { headers: headers })
    }

    public addmasteraedmake(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/make/add', formData, { headers: headers })
    }

    // Customer Classification API methods
    public listClassifications(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            this.xhr = this.http.post(this.API_URL + 'master/classification/list', params, { headers: headers })
                .subscribe(
                    response => {
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public listClassificationsForDropdown() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/classification/list',
            { show_all: true },
            { headers: headers })
    }

    public addClassification(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/classification/add', formData, { headers: headers })
    }

    public viewClassification(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/classification/view', {
            classification_id: id
        }, { headers: headers })
    }

    public updateClassification(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/classification/update', formData, { headers: headers })
    }

    public deleteClassification(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/classification/delete',
            formData,
            { headers: headers })
    }

    // Customer Type API methods
    public listCustomerTypes(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            this.xhr = this.http.post(this.API_URL + 'master/customer-type/list', params, { headers: headers })
                .subscribe(
                    response => {
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public listCustomerTypesForDropdown() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/customer-type/list',
            { show_all: true },
            { headers: headers })
    }

    public addCustomerType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/customer-type/add', formData, { headers: headers })
    }

    public viewCustomerType(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/customer-type/view', {
            customer_type_id: id
        }, { headers: headers })
    }

    public updateCustomerType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/customer-type/update', formData, { headers: headers })
    }

    public deleteCustomerType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/customer-type/delete',
            formData,
            { headers: headers })
    }

    public listPlanTypes(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            this.xhr = this.http.post(this.API_URL + 'master/plan-type/list', params, { headers: headers })
                .subscribe(
                    response => {
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public listPlanTypesForDropdown() {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/plan-type/list',
            { show_all: true },
            { headers: headers })
    }

    /**
     * Plan type categories as {key, value} options for a dropdown, taken from the
     * master list (Admin Settings) so types added later, like Concierge, show up
     * without a code change. Falls back to the original four if the call fails, so
     * a picker is never left empty.
     */
    public getPlanTypeOptions(): Observable<any[]> {
        return this.listPlanTypesForDropdown().pipe(
            map((response: any) => {
                const payload = (response && response.data) ? response.data : [];
                const rows = Array.isArray(payload) ? payload : (payload.data || []);
                if (!rows.length) {
                    return ProfileService.DEFAULT_PLAN_TYPE_OPTIONS;
                }
                return rows.map((planType: any) => ({
                    key: planType.name,
                    value: Number(planType.plan_type_id)
                }));
            }),
            catchError(() => of(ProfileService.DEFAULT_PLAN_TYPE_OPTIONS))
        );
    }

    public addPlanType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/plan-type/add', formData, { headers: headers })
    }

    public viewPlanType(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/plan-type/view', {
            plan_type_id: id
        }, { headers: headers })
    }

    public updatePlanType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/plan-type/update', formData, { headers: headers })
    }

    public deletePlanType(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/plan-type/delete',
            formData,
            { headers: headers })
    }

    // public listmastermodel(params) {
    //    const headers = this.httpUtils.getHTTPHeaders();
    //    return this.http.post(this.API_URL+'master/model/list',params,{headers:headers})
    // }

    public listmastermodel(params): Observable<any> {
        this.showLoader(true);
        this.apiResponse = false;
        const headers = this.httpUtils.getHTTPHeaders();
        return new Observable(observer => {
            this.xhr = this.http.post(this.API_URL + 'master/model/list', params, { headers: headers })
                .subscribe(
                    response => {
                        
                        observer.next(response);
                        this.showLoader(false);
                    });
        });
    }

    public addmastermodel(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/model/add', formData, { headers: headers })
    }

    public viewmasteraedmodel(id) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/model/view', {
            model_id: id
        }, { headers: headers })
    }

    public deletemasteraedmodel(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/model/delete',
            formData,
            { headers: headers })
    }

    public editmasteraedmodel(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'master/model/update', formData, { headers: headers })
    }


    showLoader(showLoader: boolean) {
        // document.getElementById('loading').style.display = showLoader ? 'block' : 'none';
    }


    // getAllBanners(pageNo, pageSize) {
    //     const headers = this.httpUtils.getHTTPHeaders();
    //     return this.http.get(globals.base_url + `getBannerlist/${pageNo}/${pageSize}`);
    // }

    // changeBannerStatus(formData) {
    //     return this.http.put(globals.base_url + 'bannerStatus', formData);
    // }

    // deleteBanners(formData) {
    //     return this.http.post(globals.base_url + 'deleteBanner', formData);
    // }

    public _image: BehaviorSubject<any> = new BehaviorSubject(null);
    setImage(value) {
        if (value) {
            this._image.next(value);
        } else {
            this._image.next(null);
        }
    }

    public _email: BehaviorSubject<any> = new BehaviorSubject(null);
    setEmail(value) {
        if (value) {
            this._email.next(value);
        } else {
            this._email.next(null);
        }
    }

    public _name: BehaviorSubject<any> = new BehaviorSubject(null);
    setName(value) {
        if (value) {
            this._name.next(value);
        } else {
            this._name.next(null);
        }
    }

    private _imageUrl;

    updateProfile(formData) {
        const headers = new HttpHeaders();
        // headers.set('Content-Type', undefined);
        return this.http.post(globals.updateProfile, formData);
    }

    updatePassword(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(globals.changePassword, formData, { headers: headers });
    }

    getProfile() {
        const headers = this.httpUtils.getHTTPHeaders();
        let user_id: string = <string>localStorage.getItem('loginId');
        if (user_id === '' || user_id === undefined || user_id == null)
            user_id = '71';
        return this.http.post(globals.getProfile,{ headers: headers });
    }

    getUdo() {
        return this.http.get(globals.getOdo);
    }

    getMakeList() {
        return this.http.get(globals.getMakeList);
    }

    getCategories() {
        return this.http.get(globals.carPreference);
    }

    getCities() {
        return this.http.get(globals.getCities);
    }

    public addMediaNote(formData) {
        const headers = this.httpUtils.getHTTPHeaders();

        return this.http.post(this.API_URL + 'company/note/add',
            formData, { headers: headers });
    }

    public getNotesByCompany(id, page) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'company/note/list', {
            company_id: id, page: page
        }, { headers: headers })
    }

    public addSubscription(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'subscription/add',
            formData, { headers: headers });
    }

    public addResellerSubscription(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'reseller-subscription/add-aed',
            formData,  { headers: headers });
    }
    public updateSubscription(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'subscription/edit',
            formData, { headers: headers });
    }

    public deleteMediaNote(formData) {
        const headers = this.httpUtils.getHTTPHeaders();

        return this.http.post(this.API_URL + 'company/note/delete',
            formData, { headers: headers });
    }

    public deleteAED(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'aed/delete',
            formData,
            { headers: headers })
    }

    public addUserManual(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'user_manual/add',
            formData, { headers: headers });
    }

    public addInspector(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'global-inspector/add',
            formData, { headers: headers });
    }

    public updateUserManual(formData) {
        const headers = this.httpUtils.getHTTPHeaders();
        return this.http.post(this.API_URL + 'user_manual/update',
            formData, { headers: headers });
    }

}
